import Input from "ant-design-vue/lib/input"; // 加载 JS
import "ant-design-vue/lib/input/style/css"; // 加载 CSS
import Vue from "vue";
Vue.use(Input);
const textareaMixin = {
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false,
    fieldStyle: {
      type: String,
      default: "style1"
    }
  },
  data() {
    return {
      fieldObj: {},
      inputValue: this.fieldValue || ""
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      this.$emit("update:fieldValue", {
        VerifyFail: this.fieldObj.dirty && this.fieldObj.invalid,
        fieldName: this.fieldObj.fieldName,
        value: this.inputValue
      });
      this.$emit("update:fieldResult", this.fieldObj);
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = "请回答";
    }
    this.fieldObj = new window.$sk.Text(this.field);
    if (this.fieldValue) this.fieldObj.setValue(this.inputValue);
  },
  methods: {
    textChange() {
      this.fieldObj.setValue(this.inputValue);
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value: this.inputValue,
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    }
  }
};
export default textareaMixin;
